import {
  READ_DATA_TO_ATTRIBUTE,
  UPDATE_DATA_TO_ATTRIBUTE,
  DELETE_DATA_TO_ATTRIBUTE,
  CREATE_DATA_TO_ATTRIBUTE,
  SHOW_HIDE_DATA_ATTRIBUTE_TABLE,
  SET_ATTRIBUTE_TABLE_ID,
} from './actionTypes';

import axios from 'axios';
import { toast } from 'react-toastify';

const { REACT_APP_HOST, REACT_APP_PORT } = process.env;

const api = {
  create: `${REACT_APP_HOST}:${REACT_APP_PORT}/spatial/attributecreate`,
  read: `${REACT_APP_HOST}:${REACT_APP_PORT}/spatial/attributeread`,
  update: `${REACT_APP_HOST}:${REACT_APP_PORT}/spatial/attributeupdate`,
  delete: `${REACT_APP_HOST}:${REACT_APP_PORT}/spatial/attributedelete`,
};

export const createDataToAttribute =
  (objectid, tableData) => async (dispatch) => {
    let data = await axios({
      method: 'POST',
      url: api.create,
      data: { objectid, tableData },
    })
      .then((response) => {
        let body = response.data.body;
        if (body.length == 0) {
          return false;
        } else {
          toast.success('Öznitelik bilgisi başarıyla eklendi.')
          body.forEach((element) => {
            dispatch({
              type: CREATE_DATA_TO_ATTRIBUTE,
              payload: element,
            });
          });
          return body;
        }
      })
      .catch((err) => err);
    return data;
  };

export const readDataToAttribute = (objectid) => async (dispatch) => {
  let data = await axios({
    method: 'POST',
    url: api.read,
    data: { objectid },
  })
    .then((response) => {
      let body = response.data.body;
      if (body.length == 0) {
        return false;
      } else {
        body.forEach((element) => {
          delete element.objectid;
          delete element.userid;
          delete element.geom;
          dispatch({
            type: READ_DATA_TO_ATTRIBUTE,
            payload: element,
          });
        });
        return body;
      }
    })
    .catch((err) => console.log(err));
  return data;
};

export const updateDataToAttribute = () => async (dispatch) => {};

export const deleteDataToAttribute = (objectid, column) => async (dispatch) => {
  let data = await axios({
    method: 'POST',
    url: api.delete,
    data: { objectid, column },
  })
    .then((response) => {
      let body = response.data.body;
      if (body.length == 0) {
        return false;
      } else {
        toast.success('Öznitelik bilgisi başarıyla silindi.')
        body.forEach((element) => {
          dispatch({
            type: DELETE_DATA_TO_ATTRIBUTE,
            payload: element,
          });
        });
        return body;
      }
    })
    .catch((err) => err);
  return data;
};

export const showHideAttributeTable = (state) => (dispatch) => {
  dispatch({
    type: SHOW_HIDE_DATA_ATTRIBUTE_TABLE,
    payload: state,
  });
};

export const setAttributeTableId = (state) => (dispatch) => {
  dispatch({
    type: SET_ATTRIBUTE_TABLE_ID,
    payload: state,
  });
};
